import { Component, Host, h, Element, Prop, Method } from '@stencil/core';
import { MuuriInterface, MuuriHelper } from '../../utils/muuri-interface';
import MuuriGrid from 'muuri';

export declare type Muuri = MuuriGrid;

/**
 * @slot  - Slot designed to add content in the list component.
 */

@Component({
  tag: 'sy-list',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class List implements MuuriInterface {
  private grid: Muuri | undefined;

  @Element() el: HTMLSyListElement;

  /**
   * Muuri's grid item selector.
   */
  @Prop({ reflect: true }) gridItemSelector = 'sy-list-item';

  /**
   * Muuri's grid handle selector.
   */
  @Prop() gridHandleSelector: string;

  /**
   * Muuri's grid constructor options.
   */
  @Prop() gridOptions: { [key: string]: any };

  /**
   * Set the list as sortable.
   */
  @Prop({ reflect: true }) sortable = false;

  /**
   * Use to get Muuri grid instance.
   */
  @Method()
  async getGrid(): Promise<Muuri | undefined> {
    return this.grid;
  }

  componentDidRender() {
    if (this.sortable) {
      this.grid = MuuriHelper.createGrid(this);
    }
  }

  componentWillUpdate() {
    if (this.grid) {
      MuuriHelper.destroyGrid(this.grid);
    }
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
